import {combineReducers} from '@reduxjs/toolkit';

import {assignAccountEntitlementsStateSlice} from './slices/assign-account-entitlements-state.slice';
import {assignAccountEntitlementsSlice} from './slices/assign-account-entitlements.slice';

export const assignAccountEntitlementsReducer = combineReducers({
    result: assignAccountEntitlementsSlice.reducer,
    state: assignAccountEntitlementsStateSlice.reducer,
});
